/**
 * Enum for tracking data upload and processing statuses.
 */
enum TrackingDataStatus {
  PENDING = 'PENDING',
  UPLOADED = 'UPLOADED', 
  PROCESSING = 'PROCESSING',
  COMPLETE = 'COMPLETE',
  ERROR = 'ERROR'
}

/**
 * Array of all tracking data status values for use in database schemas
 */
export const TrackingDataStatusValues = Object.values(TrackingDataStatus);

export default TrackingDataStatus; 